/**
 * Registers the slice's translations into the shared "expert" namespace.
 *
 * The foundation bundles i18n resources inline at init (see lib/i18n/i18n.ts);
 * feature slices add their own keys with addResourceBundle rather than editing
 * the shared locale JSON. deep+overwrite merges these over the placeholder
 * `expert.title`/`placeholder` seeded there. Importing this module for its side
 * effect (from index.tsx) is enough — it runs once at load.
 */
import i18n from "@/lib/i18n/i18n";

import { expertEn } from "./locales/en";
import { expertFr } from "./locales/fr";

i18n.addResourceBundle("fr", "translation", { expert: expertFr }, true, true);
i18n.addResourceBundle("en", "translation", { expert: expertEn }, true, true);
